import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { AyudaComponent } from './pages/maestros/ayuda/ayuda.component';
import { PrivacyAdviceComponent } from './pages/privacy-advice/privacy-advice.component';
import { LoggedInAuthGuard } from './_helpers/loggedIn-auth.guard';
import { LandingComponent } from './pages/landing/landing.component';
import { QueEsCuantrixComponent } from './components/que-es-cuantrix/que-es-cuantrix.component';
import { ContactoComponent } from './pages/contacto/contacto.component';

const routes: Routes = [
  { path: '', component: LandingComponent, canActivate: [LoggedInAuthGuard] },

  { path: 'inicio', component: HomeComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'que-es-cuantrix', component: QueEsCuantrixComponent, canActivate: [LoggedInAuthGuard] },
  { path: 'aviso-privacidad', component: PrivacyAdviceComponent },
  { path: 'contacto', component: ContactoComponent, canActivate: [LoggedInAuthGuard] },
  // Students routes
  { path: 'alumno', loadChildren: () => import('./alumnos/alumnos.module').then(m => m.AlumnosModule) },

  // Teachers routes
  { path: 'maestro', loadChildren: () => import('./maestros/maestros.module').then(m => m.MaestrosModule) },

  // Parents routes
  { path: 'padres', loadChildren: () => import('./padres/padres.module').then(m => m.PadresModule) },

  // Shared routes
  { path: 'ayuda', component: AyudaComponent, canActivate: [LoggedInAuthGuard] },

  { path: '**', component: HomeComponent, canActivate: [LoggedInAuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
